import { render, staticRenderFns } from "./FormulaDlg.vue?vue&type=template&id=53c92143&scoped=true"
import script from "./FormulaDlg.vue?vue&type=script&lang=js"
export * from "./FormulaDlg.vue?vue&type=script&lang=js"
import style0 from "./FormulaDlg.vue?vue&type=style&index=0&id=53c92143&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c92143",
  null
  
)

export default component.exports